"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModerationResolution = exports.ModerationStatus = void 0;
/**
 * Moderation Status Enum
 *
 * Represents the status of a moderation decision.
 * Used across moderation queue items, review moderation, material contributions,
 * appeals, and other moderation workflows.
 *
 * Consumers: lambda-main, lambda-secure, lambda-utilities, free-pattern-warehouse-website
 */
var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["PENDING"] = "pending";
    ModerationStatus["APPROVED"] = "approved";
    ModerationStatus["REJECTED"] = "rejected";
    ModerationStatus["ACKNOWLEDGED"] = "acknowledged";
    ModerationStatus["CLOSED"] = "closed";
})(ModerationStatus || (exports.ModerationStatus = ModerationStatus = {}));
/**
 * Moderation Resolution Enum
 *
 * Subset of ModerationStatus used specifically for resolution decisions.
 * Used in moderation-unified.ts and moderation queue resolution flows.
 *
 * Consumers: lambda-secure, free-pattern-warehouse-website
 */
var ModerationResolution;
(function (ModerationResolution) {
    ModerationResolution["APPROVED"] = "approved";
    ModerationResolution["REJECTED"] = "rejected";
    ModerationResolution["ACKNOWLEDGED"] = "acknowledged";
})(ModerationResolution || (exports.ModerationResolution = ModerationResolution = {}));
